import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { catchError, map, tap } from "rxjs/operators";
import { TokenService } from "../services/token.service";
import { LocalStorageService } from "../services/local-storage.service";
import { of } from "rxjs";

export const encQueryGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const tokenService = inject(TokenService);
    const localStorageService = inject(LocalStorageService);
    const router = inject(Router);

    if (state.url.includes("payment-response")) {
        return of(true);
    }

    const encParam = route.queryParamMap.get("enc");

    if (encParam) {
        localStorageService.clearLocalStorage();
        return tokenService.decrypt$(encParam).pipe(
            tap((accessToken) => {
                localStorageService.setAccessToken(accessToken);
            }),
            map(() => true),
            catchError(() => {
                router.navigateByUrl("/error", { skipLocationChange: true });
                return of(false);
            }),
        );
    }

    if (localStorageService.isLoggedIn()) {
        return of(true);
    }

    router.navigateByUrl("/error", { skipLocationChange: true });
    return of(false);
};

export const strictEncQueryGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const encParam = route.queryParamMap.get("enc");
    const router = inject(Router);

    if (!encParam) {
        router.navigateByUrl("/error", { skipLocationChange: true });
        return of(false);
    }

    return of(true);
};
